/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FileAttachmentResponse,
  UploadAttachments200Response,
} from '../models/index';
import {
    FileAttachmentResponseFromJSON,
    FileAttachmentResponseToJSON,
    UploadAttachments200ResponseFromJSON,
    UploadAttachments200ResponseToJSON,
} from '../models/index';

export interface DeleteAttachmentRequest {
    attachmentId: number;
}

export interface GetAttachmentsResourceIdRequest {
    ressourceId: number;
}

export interface GetFilesByAttachmentIdsRequest {
    attachmentIds: Array<number>;
}

export interface UploadAttachmentsRequest {
    files?: Array<Blob>;
    modelName?: string;
    id?: number;
}

/**
 * 
 */
export class AttachmentApi extends runtime.BaseAPI {

    /**
     * Delete an attachment by ID
     */
    async deleteAttachmentRaw(requestParameters: DeleteAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['attachmentId'] == null) {
            throw new runtime.RequiredError(
                'attachmentId',
                'Required parameter "attachmentId" was null or undefined when calling deleteAttachment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/attachment/files/{attachmentId}`;
        urlPath = urlPath.replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters['attachmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an attachment by ID
     */
    async deleteAttachment(requestParameters: DeleteAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAttachmentRaw(requestParameters, initOverrides);
    }

    /**
     * Get attachments for a specific resource ID
     */
    async getAttachmentsResourceIdRaw(requestParameters: GetAttachmentsResourceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters['ressourceId'] == null) {
            throw new runtime.RequiredError(
                'ressourceId',
                'Required parameter "ressourceId" was null or undefined when calling getAttachmentsResourceId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/attachment/ressource/{ressourceId}`;
        urlPath = urlPath.replace(`{${"ressourceId"}}`, encodeURIComponent(String(requestParameters['ressourceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get attachments for a specific resource ID
     */
    async getAttachmentsResourceId(requestParameters: GetAttachmentsResourceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getAttachmentsResourceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Files for a specific attachments ID
     */
    async getFilesByAttachmentIdsRaw(requestParameters: GetFilesByAttachmentIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileAttachmentResponse>> {
        if (requestParameters['attachmentIds'] == null) {
            throw new runtime.RequiredError(
                'attachmentIds',
                'Required parameter "attachmentIds" was null or undefined when calling getFilesByAttachmentIds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/attachment/files/{attachmentIds}`;
        urlPath = urlPath.replace(`{${"attachmentIds"}}`, encodeURIComponent(String(requestParameters['attachmentIds'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileAttachmentResponseFromJSON(jsonValue));
    }

    /**
     * Get Files for a specific attachments ID
     */
    async getFilesByAttachmentIds(requestParameters: GetFilesByAttachmentIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileAttachmentResponse> {
        const response = await this.getFilesByAttachmentIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload an attachments
     */
    async uploadAttachmentsRaw(requestParameters: UploadAttachmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadAttachments200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['files'] != null) {
            requestParameters['files'].forEach((element) => {
                formParams.append('files', element as any);
            })
        }

        if (requestParameters['modelName'] != null) {
            formParams.append('modelName', requestParameters['modelName'] as any);
        }

        if (requestParameters['id'] != null) {
            formParams.append('id', requestParameters['id'] as any);
        }


        let urlPath = `/attachment/upload`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadAttachments200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload an attachments
     */
    async uploadAttachments(requestParameters: UploadAttachmentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadAttachments200Response> {
        const response = await this.uploadAttachmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
